import React, { Fragment, useEffect } from "react";
import "../CoinWallet/index.css";
import "./edit.css";
import withDashboard from "../../HOC/withDashboard";
import BtcImg from "../../assets/bitcoin.png";
import EthImg from "../../assets/ethereum.png";
import UsdtImg from "../../assets/usdt.png";
import { Button, Switch, TextField } from "@mui/material";
import CardLayout from "../../components/CardLayout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { setBtc } from "../../redux/actions/btcAction";
import { setETH } from "../../redux/actions/ethAction";
import { setUSDT } from "../../redux/actions/usdtAction";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "../../assets/avatars/avatar4.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { getUser, setUser, updateOrder } from "../../redux/actions/userAction";
import Swal from "sweetalert2";
import {
    getDWRequestById,
    updateDWRequestData,
} from "../../redux/actions/customReferralAction";
import { useNavigate, useParams } from "react-router-dom";

const DWRequestEdit = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const User = useSelector(({ User }) => User);
    const { selectedOrder, messageText, shouldAddMessage } = User;
    const { currency } = selectedOrder || {};

    const [withdrawRequestData, setWithdrawRequestData] = React.useState({});

    const onComplete = () => {
        const orderId = id;
        let data = {
            status: "completed",
            orderId,
        };
        if (shouldAddMessage) {
            data.message = messageText;
        }
        dispatch(
            updateDWRequestData({
                data,
                navigate,
            })
        );
    };

    const onMessageChange = (e) => {
        const value = e.target.value;
        dispatch(
            setUser({
                name: "messageText",
                value,
            })
        ); 
    };

    const onReject = () => {
        const orderId = id;
        let data = {
            status: "rejected",
            orderId,
        };
        if (shouldAddMessage) {
            data.message = messageText;
        }
        dispatch(
            updateDWRequestData({
                data,
                navigate,
            })
        );
    };

    const CopyToClipboard = (data) => {
        navigator.clipboard.writeText(data);
        Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Copied to Clipboard",
            showConfirmButton: false,
            timer: 1500,
        });
    };
    useEffect(() => {
        fetchData();
    }, [id]);
    const fetchData = async () => {
        const response = await dispatch(getDWRequestById(id));
        // If your action returns a payload, extract it accordingly
        console.log({ response });
        setWithdrawRequestData(response);
    };

    return (
        <div className="wallets-container">
            <CardLayout>
                <div className="coinwallet-back-btn">
                    <Button variant="outlined" onClick={() => navigate(-1)}>
                        <ArrowBackIcon /> Back
                    </Button>
                </div>
                <div className="review-order-container">
                    <div className="review-order-user-container">
                        <div className="review-order-user-img-container">
                            <img
                                src={Avatar}
                                className="review-order-user-img"
                                alt="card.png"
                            />
                        </div>
                        <div className="review-transaction-item">
                            <div className="review-transaction-title">
                                Name:
                            </div>
                            <div className="review-transaction-value">
                                {withdrawRequestData?.userId?.name}
                            </div>
                        </div>
                        <div className="review-transaction-item">
                            <div className="review-transaction-title">
                                UserName:
                            </div>
                            <div className="review-transaction-value">
                                {withdrawRequestData?.userId?.userName}
                            </div>
                        </div>
                        <div className="review-transaction-item">
                            <div className="review-transaction-title">
                                Email:
                            </div>
                            <div className="review-transaction-value">
                                {withdrawRequestData?.userId?.email}
                            </div>
                        </div>
                        <div className="review-transaction-item">
                            <div className="review-transaction-title">
                                Phone Number:
                            </div>
                            <div className="review-transaction-value">
                                {withdrawRequestData?.userId?.phoneNumber}
                            </div>
                        </div>
                        <div className="review-transaction-item border-bottom-none">
                            <div className="review-transaction-title">
                                Country:
                            </div>
                            <div className="review-transaction-value">
                                {withdrawRequestData?.userId?.country}
                            </div>
                        </div>
                        <div className="buy-order-review-container">
                            <div className="buy-order-review-title">
                                Bank Account Details
                            </div>
                            <div className="buy-order-review-item">
                                <div className="buy-order-review-item-title">
                                    Account Holder
                                </div>
                                <div className="buy-order-review-value">
                                    {withdrawRequestData?.accountHolder}
                                    <span
                                        onClick={() =>
                                            CopyToClipboard(
                                                withdrawRequestData?.accountHolder
                                            )
                                        }
                                        className="copy-icon-container">
                                        <ContentCopyIcon />
                                    </span>
                                </div>
                            </div>
                            <div className="buy-order-review-item">
                                <div className="buy-order-review-item-title">
                                    Account Number
                                </div>
                                <div className="buy-order-review-value">
                                    {withdrawRequestData?.accountNumber}
                                    <span
                                        onClick={() =>
                                            CopyToClipboard(
                                                withdrawRequestData?.accountNumber
                                            )
                                        }
                                        className="copy-icon-container">
                                        <ContentCopyIcon />
                                    </span>
                                </div>
                            </div>
                            <div className="buy-order-review-item border-bottom-none">
                                <div className="buy-order-review-item-title">
                                    Bank Name
                                </div>
                                <div className="buy-order-review-value">
                                    {withdrawRequestData?.bankName}
                                    <span
                                        onClick={() =>
                                            CopyToClipboard(
                                                withdrawRequestData?.bankName
                                            )
                                        }
                                        className="copy-icon-container">
                                        <ContentCopyIcon />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="review-order-info-container">
                        <div className="buy-order-review-container">
                            <div className="buy-order-review-title">
                                Order Details
                            </div>
                            <div className="buy-order-review-item">
                                <div className="buy-order-review-item-title">
                                    Order Status
                                </div>
                                <div className="buy-order-review-value">
                                    {withdrawRequestData?.status}
                                </div>
                            </div>
                            <div className="buy-order-review-item">
                                <div className="buy-order-review-item-title">
                                    Order Type
                                </div>
                                <div className="buy-order-review-value">
                                    {withdrawRequestData?.type}
                                </div>
                            </div>
                            <div className="buy-order-review-item">
                                <div className="buy-order-review-item-title">
                                    {"Currency Received"}
                                </div>
                                <div className="buy-order-review-value">
                                    <div className="buy-order-review-value-text">
                                        {
                                            <Fragment>
                                                <span className="crypto-sent-img">
                                                    {"🇳🇬"}
                                                </span>
                                                {withdrawRequestData?.amount}{" "}
                                                {currency}
                                            </Fragment>
                                        }
                                    </div>
                                    <span
                                        className="copy-icon-container"
                                        onClick={() =>
                                            CopyToClipboard(
                                                withdrawRequestData?.amount
                                            )
                                        }>
                                        <ContentCopyIcon />
                                    </span>
                                </div>
                            </div>
                        </div>

                        {withdrawRequestData?.status === "pending" && (
                            <Fragment>
                                <div className="reason-switch-container-row">
                                    <div className="reason-switch-container">
                                        <span className="reason-switch-container-label">
                                            Add Message
                                        </span>
                                        <span className="reason-switch-value">
                                            No
                                        </span>
                                        <Switch
                                            inputProps={{
                                                "aria-label": "controlled",
                                            }}
                                            checked={shouldAddMessage}
                                            onChange={() => {
                                                dispatch(
                                                    setUser({
                                                        name: "shouldAddMessage",
                                                        value: !shouldAddMessage,
                                                    })
                                                );
                                            }}
                                        />
                                        <span className="reason-switch-value">
                                            Yes
                                        </span>
                                    </div>
                                </div>
                                {shouldAddMessage && (
                                    <div className="reason-textarea-container">
                                        <TextField
                                            label="Message(optional)"
                                            multiline
                                            rows={4}
                                            className="reason-textarea"
                                            value={messageText}
                                            onChange={onMessageChange}
                                        />
                                    </div>
                                )}

                                <div className="review-order-btn-container">
                                    <Button
                                        variant="contained"
                                        className="review-order-btn reject"
                                        onClick={onReject}>
                                        Reject
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className="review-order-btn completed"
                                        onClick={onComplete}>
                                        Complete
                                    </Button>
                                </div>
                            </Fragment>
                        )}
                    </div>
                </div>
            </CardLayout>
        </div>
    );
};

export default withDashboard(DWRequestEdit);
